import Vue from "vue";
import Router from "vue-router";
import LoginPage from "./views/LoginPage.vue";
import LandingPage from "./views/LandingPage.vue";
Vue.use(Router);

let router = new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/login",
      name: "Login",
      components: {
        header: "",
        default: LoginPage,
        footer: ""
      }
    },
    {
      path: "/LandingPage",
      name: "LandingPage",
      components: {
        header: "",
        default: LandingPage,
        footer: ""
      }
    },
  ]
});
router.beforeResolve((to, from, next) => {
  var isLoggedIn = (typeof(sessionStorage.accessToken)=="undefined")||sessionStorage.accessToken==""?false:true
  if (!isLoggedIn && to.path != "/login") {
    next("/login")
  }
  else if (isLoggedIn && to.path == "/") {
    if (from.path == "/") {
      next("LandingPage")
    }
    else {
      next(from.path)
    }
  }
  else if (to.path == "/login" && isLoggedIn) {
    next("/LandingPage")
  }
  else {
    next()
  }
})
export default router;
